export default "__VITE_ASSET__58302ba8__"